export default __webpack_public_path__ + "static/media/comp.8a4a96da.svg";